<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import type { HamburgerClickedEvent } from "./HamburgerButtonClickedEvent";
    
	interface Props {
		menuOpen?: boolean;
	}

	let { menuOpen = false }: Props = $props();
    const dispatch = createEventDispatcher<{
        click: HamburgerClickedEvent;
    }>();
</script>

<button 
	class="header__toggle" 
	class:opened={menuOpen}
	type="button" 
	aria-controls="navbarNav" 
	aria-expanded="false" 
	aria-label="Toggle navigation"
	onclick={() => dispatch('click', { isOpen: !menuOpen })}
>
</button>

<style>
    .header__toggle {
		background: none;
		border: none;
		height: 50px;
		width: 50px;
		position: relative;

		&:after,
		&:before {
			content: '';
			display: block;
			background: #FFF;
			height: 2px;
			width: calc(100% - 10px);
			position: absolute;
			top: 33%;
			left: 50%;
			transform: translateX(-50%);
		}

		&:after {
			top: 66%;
		}
	}

    .header__toggle.opened {
		&:after {
			top: 50%;
			transform: translateX(-50%) rotate(45deg);
		}

		&:before {
			top: 50%;
			transform: translateX(-50%) rotate(-45deg);
		}
	}

    @media (min-width: 768px) {
        .header__toggle {
            display: none;
        }
    }

</style>